module.exports = __webpack_public_path__ + "static/img/news15.1fd5e80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/newscenter/news15.jpg
// module id = YuUh
// module chunks = 0